module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "duration": {
        enter: 0,
        leave: 500
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planetOpen),
      expression: "planetOpen"
    }],
    staticClass: "box__AboutMe"
  }, [_c('header', [_c('h2', [_vm._v("- Gore Wang (王偉泰) -")])]), _c('div', {
    staticClass: "container__bg"
  }, [_c('section', [_c('h3', [_vm._v("[ 工作經歷 ]")]), _c('p', {
    staticClass: "p_company"
  }, [_vm._v("燿麒科技")]), _c('p', [_c('span', [_vm._v("新版愛在轉角")]), _vm._v("：網站開發、")]), _c('p', [_c('span', [_vm._v("易賾單品商城")]), _vm._v("：網站開發、")]), _c('p', [_c('span', [_vm._v("韋氏中醫")]), _vm._v("：形象官網、WebVR應用開發、")]), _c('p', [_c('span', [_vm._v("愛在轉角")]), _vm._v("：網站的維護，「愛在發聲」開發、")]), _c('p', {
    staticClass: "p_company"
  }, [_vm._v("謎攻城工作室")]), _c('p', [_vm._v("企劃、製作、平面設計、網站設計、主持")]), _c('h3', [_vm._v("[ 技術分享 ]")]), _c('p', [_c('a', {
    attrs: {
      "href": "http://slides.com/gorestarry/deck-2#/"
    }
  }, [_vm._v("WebVR vs Chinese @Taipei WebGL&WebVR")])]), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=bnorojYDays&t=265s"
    }
  }, [_vm._v("Draft.js @線上React讀書會")])]), _c('p', [_c('a', {
    attrs: {
      "href": "http://slides.com/gorestarry/deck#/"
    }
  }, [_vm._v("A-Frame WebVR @Web Tech Topic")])]), _c('h3', [_vm._v("[ 長處 ]")]), _c('p', [_vm._v("擅長組織溝通、邏輯分析、問題克服＆創意實現。")]), _c('h3', [_vm._v("[ 職業能力 ]")]), _c('p', [_vm._v("對不斷變動的主流前端技術有充分自主學習意願，由於自身對視覺設計也有相關涉略，能完美接收實踐來自設計端的細節需求，更願意從工程技術面的角度來錦上添花。")]), _c('p', [_vm._v("無論效能、視覺、產品企劃，都有解決問題向前邁進的熱情與能力。")]), _c('h3', [_vm._v("[ 態度 ]")]), _c('p', [_vm._v("作為一個曾參與創業的經驗者，我能理解細節要求對於產品成敗的關鍵性。")]), _c('p', [_vm._v("所以對於工作上的要求，我絕不會被牽制在一個「我覺得沒差」的心理狀態，而願意將工作務實的做到更高的需求層級。")]), _c('h3', [_vm._v("[ 熱情 ]")]), _c('p', [_vm._v("對於實現製作好的產品有很大的熱情，樂於征服市場與使用者。")]), _c('p', [_vm._v("也會不斷自主學習新技術，並願意主動提案分享討論新技術應用方向。")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11ce9cd0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/container/index/components/AboutMe/AboutMe.vue
// module id = 56
// module chunks = 0